import React from 'react'
import { AppConfigCodec, loadConfigGenericFromFile } from '@amzn/aapn-front-end-config-lib'
import * as io from 'io-ts/es6'
import * as TE from 'fp-ts/es6/TaskEither'

export const StageDiveConfigCodec = io.intersection([
  AppConfigCodec,
  io.type({
    apiRegistrationEndpoint: io.string,
    useApiFormMockAxios: io.boolean,
    apiMarketplaceId: io.string,
    apiClientId: io.string,
    useFedApiGateway: io.boolean,
    authPortalEndpoint: io.string,
    hostname: io.string,
    partnerDirectoryUrl: io.string,
    metricsEndpoint: io.intersection([
      io.type({
        stage: io.string,
        site: io.string,
        app: io.string,
      }),
      io.partial({
        user: io.string,
        realm: io.string,
      }),
    ]),
    metricsEndpointForTestDataSet: io.intersection([
      io.type({
        stage: io.string,
      }),
      io.partial({
        site: io.string,
        app: io.string,
        user: io.string,
        realm: io.string,
      }),
    ]),
    useApiRegistrationProductionOid: io.boolean,
    stage: io.union([io.literal('dev'), io.literal('alpha'), io.literal('beta'), io.literal('gamma'), io.literal('prod')]),
  }),
])

export type StageDiveConfig = io.TypeOf<typeof StageDiveConfigCodec>

//The default value cannot be provided as undefined here like it is in AAPNFrontEndConfigLib b/c our tsconfig is set to 'strict' in AAPNStageDive
//See https://kentcdodds.com/blog/how-to-use-react-context-effectively for more details on how to avoid issues with skipping default values with React context.
export const StageDiveConfigContext = React.createContext<StageDiveConfig>({
  apiEndpoint: '',
  apiMarketplaceId: 'ATVPDKIKX0DER',
  apiClientId: '',
  useFedApiGateway: false,
  authRedirectUrl: '',
  apiRegistrationEndpoint: '',
  useApiFormMockAxios: true,
  authPortalEndpoint: '',
  hostname: '',
  partnerDirectoryUrl: '',
  metricsEndpoint: {
    stage: 'dev',
    site: 'AAPN',
    app: 'AAPNStageDive',
  },
  metricsEndpointForTestDataSet: {
    stage: 'dev.test',
  },
  useApiRegistrationProductionOid: false,
  stage: 'dev',
})

export const baseName = 'partner-network'
export const baseURL = `/${baseName}`

export const loadConfig = (): TE.TaskEither<Error, StageDiveConfig> => {
  return TE.tryCatch(
    () => loadConfigGenericFromFile(eval(process.env.Config ?? ''), StageDiveConfigCodec),
    () => new Error('Failed to load configuration'),
  )
}
